<template>
  <div class="cli-auth-page">
    <div class="cli-auth-container">
      <div class="cli-auth-logo">
        <img :src="logo" alt="" class="logo-img" />
        <span class="logo-text">{{ name }}</span>
      </div>

      <div class="cli-auth-status">
        <div v-if="error" class="status-error">
          <div class="status-icon">&#9888;&#65039;</div>
          <p class="status-title">无效的授权链接</p>
          <p class="status-desc">请通过 CLI 命令重新获取授权链接</p>
        </div>

        <div v-else-if="status === 0" class="status-waiting">
          <div class="qr-code-container" ref="xcxqrcode">
            <img :src="qrCodeUrl" class="qr-code-img" alt="授权二维码" />
          </div>
          <div class="reload-btn-wrapper" ref="wrpreloadbtn" @click="reloadQrCode" style="display:none;">
            <img :src="require('@/assets/images/loginreload.png')" alt="刷新" class="reload-icon" />
          </div>
          <p class="status-title">微信扫码授权登录</p>
          <p class="status-desc">{{ message }}</p>
        </div>

        <div v-else-if="status === 1" class="status-scanned">
          <div class="qr-code-container scanned">
            <img :src="qrCodeUrl" class="qr-code-img" alt="授权二维码" />
            <div class="qr-overlay">已扫码</div>
          </div>
          <p class="status-title">已扫码，等待确认</p>
          <p class="status-desc">请在小程序中确认授权</p>
        </div>

        <div v-else-if="status === 2" class="status-success">
          <div class="status-icon">&#9989;</div>
          <p class="status-title">授权成功</p>
          <p class="status-desc">请返回 CLI 继续操作</p>
        </div>

        <div v-else-if="status === -1" class="status-expired">
          <div class="status-icon">&#9200;</div>
          <p class="status-title">二维码已过期</p>
          <p class="status-desc">请在 CLI 中重新执行登录命令</p>
          <button class="refresh-btn" @click="refreshPage">刷新页面</button>
        </div>
      </div>

      <div class="cli-auth-footer">
        <p>{{ name }} CLI 授权 · 安全便捷</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/utils/config";

export default {
  data() {
    return {
      loginKey: null,
      status: 0,
      error: false,
      pollingInterval: null,
      name: config.name,
      logo: config.logo,
      qrCodeUrl: require("@/assets/images/qrcode.jpg"),
      message: "微信扫码授权登录",
    };
  },
  mounted() {
    this.loginKey = this.$route.query.loginKey;
    if (!this.loginKey) {
      this.error = true;
      return;
    }
    this.getQrCode();
  },
  beforeDestroy() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  methods: {
    async getQrCode() {
      try {
        const response = await axios.post(
          `${process.env.API_BASE_URL}/wj/cli/auth/qrcode?loginKey=${this.loginKey}`,
          {},
          {
            headers: {
              appId: this.$store ? this.$store.getters.getAppId : "wx771820531f2d9634",
            },
          }
        );
        if (response.data.code === 200) {
          if (response.data.data.qrCodeBase64) {
            this.qrCodeUrl = `data:image/png;base64,${response.data.data.qrCodeBase64}`;
          }
          this.loginKey = response.data.data.loginKey;
          this.startPolling();
        } else {
          this.status = -1;
          this.message = response.data.msg || "获取二维码失败";
        }
      } catch (error) {
        console.error("获取二维码失败:", error);
        this.status = -1;
        this.message = "获取二维码失败，请稍后重试";
      }
    },
    startPolling() {
      this.pollingInterval = setInterval(async () => {
        try {
          const response = await axios.get(
            `${process.env.API_BASE_URL}/wj/cli/auth/check`,
            {
              params: { loginKey: this.loginKey },
            }
          );
          if (response.data.code === 200) {
            this.status = response.data.data.status;
            if (this.status === 1) {
              this.message = "已扫码，请在小程序中确认授权";
            } else if (this.status === 2) {
              clearInterval(this.pollingInterval);
              this.message = "授权成功，请返回 CLI 继续操作";
            }
          } else if (response.data.code === 500) {
            clearInterval(this.pollingInterval);
            this.status = -1;
            this.message = "二维码已过期，请重新获取";
            if (this.$refs.xcxqrcode) {
              this.$refs.xcxqrcode.style.filter = "blur(5px)";
            }
            if (this.$refs.wrpreloadbtn) {
              this.$refs.wrpreloadbtn.style.display = "block";
            }
          }
        } catch (error) {
          console.error("轮询授权状态失败:", error);
        }
      }, 3000);
    },
    reloadQrCode() {
      window.location.reload();
    },
    refreshPage() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.cli-auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.cli-auth-container {
  background: white;
  border-radius: 16px;
  padding: 48px 40px;
  width: 400px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.cli-auth-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 36px;
}

.logo-img {
  width: 40px;
  height: 40px;
  margin-right: 12px;
}

.logo-text {
  font-size: 22px;
  font-weight: 600;
  color: #333;
}

.cli-auth-status {
  margin-bottom: 32px;
}

.status-icon {
  font-size: 56px;
  margin-bottom: 20px;
}

.status-icon.scanning {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.status-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.status-desc {
  font-size: 14px;
  color: #999;
  line-height: 1.6;
}

.status-error .status-title {
  color: #e74c3c;
}

.status-success .status-title {
  color: #27ae60;
}

.status-expired .status-title {
  color: #f39c12;
}

.refresh-btn {
  margin-top: 16px;
  padding: 8px 24px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s;
}

.refresh-btn:hover {
  background: #5a6fd6;
}

.qr-code-container {
  background: white;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  display: inline-block;
}

.qr-code-img {
  width: 180px;
  height: 180px;
}

.qr-code-container.scanned {
  position: relative;
}

.qr-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: 600;
  border-radius: 8px;
}

.reload-btn-wrapper {
  cursor: pointer;
  margin-bottom: 8px;
}

.reload-icon {
  width: 32px;
  height: 32px;
}

.cli-auth-footer {
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
}

.cli-auth-footer p {
  font-size: 12px;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/CliAuthPage/index.vue